import { motion } from "framer-motion";

/* Circular certification seal — ring text + centre mark. Styled in-house
   (not an official certifying-body mark). */
export default function CertSeal({
  size = 210,
  ring = "QUALITY MANAGEMENT SYSTEM · MILL TEST CERTIFIED",
  top = "ISO",
  main = "9001:2015",
  bottom = "CERTIFIED",
  navy = false,
  spin = 26,
}) {
  const fg = navy ? "#ffffff" : "#0F2137";
  const accent = "#1B5FAA";

  return (
    <div
      className="relative shrink-0"
      style={{ width: size, height: size }}
      data-testid="cert-seal"
    >
      <motion.svg
        viewBox="0 0 200 200"
        className="absolute inset-0 w-full h-full"
        animate={{ rotate: 360 }}
        transition={{ duration: spin * 6, repeat: Infinity, ease: "linear" }}
      >
        <defs>
          <path id="sealRing" d="M100,22 a78,78 0 1,1 -0.1,0" />
        </defs>
        <circle cx="100" cy="100" r="96" fill="none" stroke={accent} strokeWidth="2" />
        <circle cx="100" cy="100" r="88" fill="none" stroke={accent} strokeWidth="6" opacity="0.14" />
        <text
          fill={fg}
          fontSize="10"
          fontWeight="700"
          letterSpacing="2.4"
          fontFamily="Public Sans, sans-serif"
          textAnchor="middle"
        >
          <textPath href="#sealRing" startOffset="50%">
            {ring}
          </textPath>
        </text>
      </motion.svg>

      <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full">
        {Array.from({ length: 60 }).map((_, i) => {
          const a = (i / 60) * Math.PI * 2;
          return (
            <line
              key={`seal-tick-${a.toFixed(3)}`}
              x1={100 + Math.cos(a) * 68}
              y1={100 + Math.sin(a) * 68}
              x2={100 + Math.cos(a) * 72}
              y2={100 + Math.sin(a) * 72}
              stroke={accent}
              strokeWidth="1.4"
              opacity="0.5"
            />
          );
        })}
        <circle cx="100" cy="100" r="66" fill="none" stroke={accent} strokeWidth="2.5" />
      </svg>

      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="flex flex-col items-center justify-center text-center leading-none"
          style={{ width: size * 0.6 }}
        >
          <span
            className="font-display font-black uppercase leading-none"
            style={{ color: accent, fontSize: size * 0.1, letterSpacing: "0.08em" }}
          >
            {top}
          </span>
          <span
            className="font-display font-black leading-none whitespace-nowrap"
            style={{ color: fg, fontSize: size * 0.104, marginTop: size * 0.018 }}
          >
            {main}
          </span>
          <span
            className="font-sans font-bold uppercase leading-none"
            style={{
              color: fg,
              opacity: 0.55,
              fontSize: size * 0.048,
              letterSpacing: "0.14em",
              marginTop: size * 0.045,
            }}
          >
            {bottom}
          </span>
        </div>
      </div>
    </div>
  );
}
